export const defaultState = () => {
  return {
    notiBar: {
      message: "",
      type: "",
      isOpen: false,
      pinnedNoti: [],
      noti: [],
      status: {
        loadingNoti: false,
        loadingMoreNoti: false,
        isModalActive: false,
      },
      action: {
        isViewingNoti: false,
        isViewingNotiContent:false,
        noti: Object
      },
      last_system_noti: Object,
      noti_list_count: 0,
      noti_list_unread: 0,
      limit_pagination: 0,
      maxAllReaded: true
    },
    autoNotiOpenId: "",
    sticky: {
      firstTime: true,
      dissMissed: false
    }
  };
};

const state = defaultState();

export default state;
